<script>
export default {
    name: "ClaimsDashBoard",

}
</script>
<template>
<tail-base-layout>
    <template v-slot:content>
        <div class="flex flex-wrap">
            <div class="w-full p-1 my-1 text-center text-white bg-blue-500 rounded">
                <h5 class="font-medium text-base">Claims</h5>
            </div>
            <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                    <router-link :to="{ name: `claims.raise.index` }" @click="$root.RecordUserActivity('User Name','User activity')">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-green-600"><i class="fas fa-cogs fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Raise Claims</h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>

            <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `claims.batching.raisedclaims` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-server fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Raised/Submitted Claims</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
           
                
            <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                <div class="bg-gray-100 border-b-4 border-gray-600 rounded-lg shadow-lg p-1">
                    <router-link :to="{ name: `claims.batching.index`}">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-gray-600"><i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Batching</h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                <div class="bg-blue-100 border-b-4 border-blue-600 rounded-lg shadow-lg p-1">
                    <router-link :to="{ name: `claims.batches.index`}">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Batches</h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                    <router-link :to="{ name: `claims.org-receipt.create` }">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600"><i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Org Receipts</h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div> <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                    <router-link :to="{ name: `claims.statement.Index` }">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600"><i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Org Payment Report</h5>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </template>
</tail-base-layout>
</template>
<style scoped>
@import  '~vue-context/dist/css/vue-context.css';
</style>